<template>
  <v-layout wrap v-if="content">
    <v-flex xs12>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
//import apiDtouch from '@/services/apiDtouch'
import utils from '@/services/utils'
export default {
  name: 'Form60Effiwaste',
  props: {
    editedItem: {
      type: Object,
      required: true
    },
    onChangeIsModified: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    content: null,
    shifts: [],
  }),
  computed: {        
    ...mapState('app', ['locale']),
    workspaceID () {
      return utils.getWorkspace('dtouch')
    },
  },
  watch: {
    editedItem () {
      this.prepareContent()
    },
  },
  mounted () {
    this.prepareContent()
  },
  methods: {
    prepareContent () {
      this.content = this.editedItem
    },
    handleChangeIsModified () {
      this.onChangeIsModified(this.content) 
    },
  },
}
</script>

